import "angular";
import "angular-aria";
import "angular-sanitize";
import "angular-route";
import "angular-cookies";
import "angular-animate";
import "angular-resource";
import "angular-translate";
import "angular-translate-loader-static-files";
import "angular-material";
import "angular-material/angular-material.css";
import "angulartics";
import "angular-locker";
import "angular-ui-tinymce";
import "moment";
import "reflect-metadata";

import "./node_modules/tinymce/";
import "./node_modules/tinymce/themes/modern/theme";
import "./node_modules/tinymce/plugins/advlist";
import "./node_modules/tinymce/plugins/image";
import "./node_modules/tinymce/plugins/imagetools";
import "./node_modules/tinymce/plugins/link";
import "./node_modules/tinymce/plugins/lists";
import "./node_modules/tinymce/plugins/searchreplace";
import "./node_modules/tinymce/plugins/wordcount";

// Import libs we depend on
import "@meltwater/gaf-ng-components";
import "@meltwater/gaf-ng-components/dist/gaf-ng-components.min.css";
import "./public/js/index.ts";
